<template>
  <div>
    <page-header :title="$t('scope.text_291')" />
    <page-body>
      <subscription-list :id="listId" :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
import SubscriptionList from './components/List'

export default {
  name: 'subscriptionIndex',
  components: {
    SubscriptionList,
  },
  data () {
    return {
      listId: 'subscription-list',
      getParams: {
        details: true,
      },
    }
  },
}
</script>
